import { render, staticRenderFns } from "./ClipboardWithoutDirective.vue?vue&type=template&id=4f1c30e3&"
import script from "./ClipboardWithoutDirective.vue?vue&type=script&lang=js&"
export * from "./ClipboardWithoutDirective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports